const europeanCities: { [key: string]: string[] } = {
  "Albania": ["Tirana", "Durrës", "Vlorë"],
  "Austria": ["Vienna", "Graz", "Salzburg", "Innsbruck"],
  "Belgium": ["Brussels", "Antwerp", "Bruges", "Ghent", "Liège"],
  "Bosnia and Herzegovina": ["Sarajevo", "Mostar", "Banja Luka"],
  "Bulgaria": ["Sofia", "Plovdiv", "Varna", "Burgas"],
  "Croatia": ["Zagreb", "Split", "Dubrovnik", "Zadar", "Rijeka"],
  "Cyprus": ["Nicosia", "Limassol", "Paphos"],
  "Czech Republic": ["Prague", "Brno", "Ostrava", "Český Krumlov"],
  "Denmark": ["Copenhagen", "Aarhus", "Odense"],
  "Estonia": ["Tallinn", "Tartu"],
  "Finland": ["Helsinki", "Tampere", "Turku"],
  "France": ["Paris", "Lyon", "Marseille", "Bordeaux", "Nice", "Strasbourg", "Toulouse", "Nantes", "Montpellier", "Cannes", "Avignon", "Reims"],
  "Germany": ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Stuttgart", "Dresden", "Leipzig", "Heidelberg", "Nuremberg", "Düsseldorf"],
  "Greece": ["Athens", "Thessaloniki", "Santorini", "Mykonos", "Heraklion", "Rhodes"],
  "Hungary": ["Budapest", "Debrecen", "Pécs"],
  "Iceland": ["Reykjavik", "Akureyri"],
  "Ireland": ["Dublin", "Cork", "Galway", "Limerick", "Kilkenny", "Waterford", "Dingle", "Westport", "Donegal", "Sligo", "Drogheda", "Wexford"],
  "Italy": ["Rome", "Milan", "Venice", "Florence", "Naples", "Turin", "Bologna", "Pisa", "Amalfi", "Siena", "Verona", "Palermo"],
  "Latvia": ["Riga", "Jūrmala"],
  "Lithuania": ["Vilnius", "Kaunas"],
  "Luxembourg": ["Luxembourg City"],
  "Malta": ["Valletta", "Mdina"],
  "Moldova": ["Chișinău"],
  "Monaco": ["Monaco"],
  "Montenegro": ["Podgorica", "Kotor", "Budva"],
  "Netherlands": ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven"],
  "North Macedonia": ["Skopje", "Ohrid"],
  "Norway": ["Oslo", "Bergen", "Tromsø", "Stavanger"],
  "Poland": ["Warsaw", "Kraków", "Gdańsk", "Wrocław", "Poznań"],
  "Portugal": ["Lisbon", "Porto", "Faro", "Sintra", "Braga", "Évora"],
  "Romania": ["Bucharest", "Cluj-Napoca", "Brasov", "Sibiu", "Timișoara"],
  "Scotland": ["Edinburgh", "Glasgow", "Inverness", "St Andrews", "Stirling"],
  "Serbia": ["Belgrade", "Novi Sad"],
  "Slovakia": ["Bratislava", "Košice"],
  "Slovenia": ["Ljubljana", "Bled"],
  "Spain": ["Madrid", "Barcelona", "Seville", "Valencia", "Granada", "Bilbao", "San Sebastián", "Málaga", "Toledo", "Salamanca", "Córdoba", "Ibiza"],
  "Sweden": ["Stockholm", "Gothenburg", "Malmö", "Uppsala"],
  "Switzerland": ["Zurich", "Geneva", "Bern", "Lucerne", "Interlaken", "Zermatt"],
  "Ukraine": ["Kyiv", "Lviv", "Odessa"],
  "United Kingdom": ["London", "Manchester", "Birmingham", "Liverpool", "Bristol", "Oxford", "Cambridge", "Bath", "York", "Brighton"],
  "Wales": ["Cardiff", "Swansea", "Newport", "Bangor", "Aberystwyth", "Brecon", "Caernarfon", "Tenby", "St Davids", "Wrexham"],
};

export default europeanCities;